import React from 'react';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

import List from '../../List/List';
import AddButton from './../../AddButton';
import LoadMore from '../../LoadMore';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';

class ManagersList extends List {
  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  render() {
    let { add, items, hasMore } = this.props;
    let {palette: {labelColor}, tableHeaderColumn} = this.context.muiTheme;
    let fixedColumn = {style: {width: 100, color: labelColor}};

    return (
      <div>
        <LoggedAppBar title={this.props.headerTitle} isStatic/>
        {items.length > 0
          ? (
          <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
            <Table selectable={false}>
              <TableHeader adjustForCheckbox={false} displaySelectAll={false} enableSelectAll={false}
                           style={{
                             backgroundColor: tableHeaderColumn.bgColor
                           }}
              >
                <TableRow>
                  <TableHeaderColumn style={{color: labelColor}}>ID</TableHeaderColumn>
                  <TableHeaderColumn style={{color: labelColor}}>Name</TableHeaderColumn>
                  <TableHeaderColumn {...fixedColumn}>Account</TableHeaderColumn>
                  <TableHeaderColumn {...fixedColumn}>Options</TableHeaderColumn>
                </TableRow>
              </TableHeader>

              <TableBody displayRowCheckbox={false}>
              {items.map(({id, last_name, first_name, club}) => (
                <TableRow key={id} >
                  <TableRowColumn>{id}</TableRowColumn>
                  <TableRowColumn>{first_name} {last_name}</TableRowColumn>
                  <TableRowColumn {...fixedColumn}>
                    {club.name}
                  </TableRowColumn>
                  <TableRowColumn {...fixedColumn}>
                    <RaisedButton onClick={() => {
                      this.props.fetchModel(id)
                      this.props.edit(id)
                    }}>Edit</RaisedButton>
                  </TableRowColumn>
                </TableRow>
              ))}
              </TableBody>
            </Table>
          </LoadMore>
        )
          : (<div>Empty list</div>)
        }

        <AddButton onClick={add} />
      </div>
    );
  }
}

export default ManagersList;




// WEBPACK FOOTER //
// ./src/components/Managers/ManagersList/ManagerList.jsx